const EmbedMap = (props:{address: string}) => {

    const src = `https://maps.google.com/maps?&q="+${props.address}"&output=embed`;

    return (
            <iframe src={src}
            width='800' height='400' style={{ border: '0' }} allowFullScreen loading='lazy' referrerPolicy='no-referrer-when-downgrade'></iframe>
    );
}
export default EmbedMap;